const sanityId = process.env.GATSBY_SANITY_ID

export async function getLiveProducts() {
  const requestOptions = {
    method: "GET",
  }
  const response = await fetch(
    `https://api.gorillashops.io/get-merged-products/${sanityId}`,
    requestOptions
  )

  if (!response.ok) {
    throw Error()
  }

  const nftProducts = await response.json()
  // eslint-disable-next-line camelcase
  return nftProducts
}
